import React from 'react';
import Slider from 'react-slick';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

const trainingSlider = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3.5, 
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2.5,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1.5,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1, 
        dots: true,
        arrows: true,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1, 
        dots: true,
        arrows: true,
      },
    },
  ],
};

const TrainingOnline = () => {    

  return (  
    <div className="cracked-section training-slider slider-dot-arrow mt-0">
      <div className="container"></div>
      <div className='slider-bleed-wrapper'>
        <Slider {...trainingSlider}>
          <div className="feature-card card1">
            <div className="rounded-circle">
              <div className="img-wrapper">
                <img
                  src="/images/web-new-images/icons/301.svg"
                  alt="LA"
                />
              </div>
            </div>
            <h3>Expert Trainers</h3>
            <p>
              Learn from experienced NAATI-accredited professionals through our NAATI online course who understand the test requirements inside out.
            </p>
          </div>
          <div className="feature-card card2">
            <div className="rounded-circle">
              <div className="img-wrapper">
                <img
                  src="/images/web-new-images/icons/302.svg"
                  alt="LA"
                />
              </div>
            </div>
            <h3>
              Personalized <br /> Feedback
            </h3>
            <p>
              Receive tailored insights through our NAATI CCL coaching to identify your weaknesses and improve your performance.
            </p>
          </div>
          <div className="feature-card card3">
            <div className="rounded-circle">
              <div className="img-wrapper">
                <img
                  src="/images/web-new-images/icons/303.svg"
                  alt="LA"
                />
              </div>
            </div>
            <h3>Online Flexibility</h3>
            <p>
              Study anytime, anywhere with our NAATI CCL Online Classes learning schedule that fits your lifestyle.
            </p>
          </div>
          <div className="feature-card card4">
            <div className="rounded-circle">
              <div className="img-wrapper">
                <img
                  src="/images/web-new-images/icons/304.svg"
                  alt="LA"
                />
              </div>
            </div>
            <h3>Comprehensive Resources</h3>
            <p>
              Access the latest vocabulary lists, practice dialogues, and mock tests.
            </p>
          </div>
          <div className="feature-card card1">
            <div className="rounded-circle">
              <div className="img-wrapper">
                <img
                  src="/images/web-new-images/icons/301.svg"
                  alt="LA"
                />
              </div>
            </div>
            <h3>Proven Success</h3>
            <p>
              Join thousands of successful students who earned their PR points with our NAATI CCL training centre coaching.
            </p>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default TrainingOnline;